// extracted by mini-css-extract-plugin
export default {"Box":"tracking-fields-module__Box--0dUZh"};